import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatEventDate } from '../utils/eventDisplay';

const {FiCheckCircle,FiClock,FiSlash} = FiIcons;

const availabilityOptions=[
  {value: 'available',label: 'Available',icon: FiCheckCircle},
  {value: 'limited',label: 'Limited',icon: FiClock},
  {value: 'unavailable',label: 'Unavailable',icon: FiSlash}
];

function AvailabilityEditor({
  selectedDate,
  selectedDj,
  value,
  note,
  onDjChange,
  onStatusChange,
  onNoteChange
}) {
  return (
    <section className="availability-editor panel">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">DJ scheduling</span>
          <h2>Availability</h2>
        </div>
        <span className="availability-local-note">Saved on this device</span>
      </div>

      <div className="availability-date">
        <strong>{formatEventDate(selectedDate.replace(
          /^(\d{4})-(\d{1,2})-(\d{1,2})$/,
          '$1-$2-$3'
        ))}</strong>
        <span>Set the availability for the selected DJ.</span>
      </div>

      <label className="availability-field">
        <span>DJ or production team</span>
        <select value={selectedDj} onChange={(event)=> onDjChange(event.target.value)}>
          <option>Asi Vidal</option>
          <option>DJ team</option>
          <option>Production team</option>
          <option>AV team</option>
        </select>
      </label>

      <div className="availability-options" aria-label="Availability status">
        {availabilityOptions.map((option)=> {
          const Icon=option.icon;
          return (
            <button
              type="button"
              key={option.value}
              className={value===option.value ? `selected ${option.value}` : ''}
              onClick={()=> onStatusChange(option.value)}
            >
              <SafeIcon icon={Icon} />
              {option.label}
            </button>
          );
        })}
      </div>

      <label className="availability-field">
        <span>Scheduling note</span>
        <textarea
          value={note}
          onChange={(event)=> onNoteChange(event.target.value)}
          placeholder="Add travel, setup or booking notes..."
          rows="3"
        />
      </label>
    </section>
  );
}

export default AvailabilityEditor;